export default __webpack_public_path__ + "static/media/spinner.2209b588.svg";